exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\nEssential imports for the global theme, but also to be used in single components\n**/\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  left: -10000px;\n}\n.visually-hidden:focus {\n  left: 20px;\n  top: 10px;\n  width: auto;\n  height: auto;\n  z-index: 9999;\n  outline: 2px dotted !important;\n}\n#jump {\n  background-color: white;\n  padding: 10px;\n}", ""]);

// exports
